import { render, staticRenderFns } from "./BtnGenerateLabelAndInvoice.vue?vue&type=template&id=0d5cbc96&scoped=true&"
import script from "./BtnGenerateLabelAndInvoice.vue?vue&type=script&lang=js&"
export * from "./BtnGenerateLabelAndInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5cbc96",
  null
  
)

export default component.exports